import { loanProcessingDefinitionsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const APPRAISAL_PRODUCT_SCHEMA_ACTION_TYPE = createNamedActions('appraisalProductSchema', {
  GET_APPRAISAL_PRODUCT_SCHEMA: 'GET_APPRAISAL_PRODUCT_SCHEMA',
});

export const getAppraisalProductSchemaParamsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await loanProcessingDefinitionsApi.getAppraisalProductExpressionDefinition();

  return dispatch({
    type: APPRAISAL_PRODUCT_SCHEMA_ACTION_TYPE.GET_APPRAISAL_PRODUCT_SCHEMA,
    payload: data,
  });
});
